import {
  Box,
  Button,
  Typography,
  Snackbar,
  Alert,
  Radio,
  AlertTitle,
  Dialog,
  DialogContent,
  DialogTitle,
  DialogContentText,
  DialogActions,
  Grid,
  IconButton,
} from "@mui/material";
import {
  DataGridPremium,
  GridToolbar,
  GridRowSelectionModel,
  GridActionsCellItem,
} from "@mui/x-data-grid-premium";

import service from "../../Services/apiheader";
import Cookies from "js-cookie";
import React, { useContext, useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import { Breadcrumbs, Stack } from "@mui/material";
import { XevmpdPackage } from "./Xevmpd-Package";
import {
  fetchRegistrationData,
  fetchRelatedProducts,
  fetchSideMenuData,
  fetchXevmpdList,
  fetchDataListByMenu,
  fetchPharmaceuticalProductData,
  fetcheligibleregistrations,
  getRegionKMCodes,
  getProductTypeKMCodes,
  getRegulatorystatusKMCodes,
  LocalRegistrationCategoryCodes,
} from "../../api/apiFunctions";
import Loading from "../../components/Loading";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import Links from "@mui/material/Link";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
import RadioButtonCheckedIcon from "@mui/icons-material/RadioButtonChecked";
import { XevmpdContext } from "../../App";
import CloseIcon from "@mui/icons-material/Close";
import WarningAmberRoundedIcon from "@mui/icons-material/WarningAmberRounded";
import AlertIcon from "../../assets/images/Alert Icon.png";
import NoDataAvailable from "../../components/NoDataAvailable";
import NoRecordsFound from "../../components/NoRecordsFound";
import { useDataGridLocalText } from "../../hooks/useDataGridLocaleText";
import { extractVersion } from "../../assets/utils";
import {
  excludeNonEuCentralisedRegistrations,
  isEuCentralisedRegistration,
  validateCentralisedEeaCreate,
} from "./centralisedRegistrationFilter";

interface ComponentsProps {}

// ✅ Normalizes fieldDataList before saving to DB
export const normalizeMenuListData = (list: any[]) => {
   if (!list || list.length === 0) {
    return [{}];
  }
  return list.map((row) => {
    const updatedRow: any = {};

    Object.keys(row).forEach((key) => {
      const val = row[key];

      // ⛔ Convert blank string → null (backend best practice)
      if (val === "") {
        updatedRow[key] = null;
        return;
      }

      // ✅ Convert object selects to raw value
      if (typeof val === "object" && val !== null && "value" in val) {
        updatedRow[key] = val.value;
        return;
      }

      // ✅ Arrays (multi-select display)
      if (Array.isArray(val)) {
        updatedRow[key] = val;
        return;
      }

      updatedRow[key] = val;
    });

    return updatedRow;
  });
};

export interface LinkSectionRef {
  getFormatCheckedValues: () => Record<string, Record<string, string[]>>;
}

const IdmpAdd: React.FC<ComponentsProps> = () => {
  const navigator = useNavigate();
  const handleEditClick = () => {
    navigator("/idmp/edit-recordinfo", { replace: true });
  };
  const { setallXevmpdRows, allXevmpdRows } = useContext(XevmpdContext);

  const [openCombined, setOpenCombined] = useState(false);
  const [rowSelectionModel, setRowSelectionModel] =
    useState<GridRowSelectionModel>([]);
  const [showWarning, setShowWarning] = useState(false);
  const [Gridrows, setGridrows] = useState<GridRow[]>([]);
  const [selectedRows, setselectedRows] = useState<any[]>([]);
  const [eleigibleRegRecords, setEleigibleRegRecords] = useState<any[]>([]);
  const [allRegistrations, setAllRegistrations] = useState<any[]>([]);
  const [eeaSiblings, setEeaSiblings] = useState<any[]>([]);
  const [createError, setCreateError] = useState("");
  const [sideMenuData, setSideMenuData] = useState<any>({});
  const [loading, setLoading] = useState<boolean>(true);
  const [openAlert, setOpenAlert] = useState(false);
  const [initiateButtonValidation, setInitiateButtonValidation] = useState(true);
  type GridRow = {
    sectionTree: any;
    id: string;
    productId: string;
    name: string;
  };
  const { localeText } = useDataGridLocalText();

  const handleNext = async () => {
    setLoading(true);
    const selectedRows = Gridrows.filter((row) =>
      rowSelectionModel.includes((row as any).id)
    );
    if (rowSelectionModel.length === 0) {
      setShowWarning(true);
      setLoading(false);
      return;
    }

    const regdata = selectedRows[0] as any;
    if (isEuCentralisedRegistration(regdata)) {
      const check = validateCentralisedEeaCreate(regdata, allRegistrations);
      if (!check.ok) {
        setCreateError(check.message);
        setLoading(false);
        return;
      }
      setEeaSiblings(check.siblings);
    } else {
      setEeaSiblings([]);
    }

    const getmenudata = async () => {
      const names = [
        "Authorisation",
        "MAH",
        "Presentation Details",
        "ATC Code(s)",
        "Product Indication",
        "Pharmacovigilance",
        "Pharmaceutical Product",
        "Attachments",
      ];

      // Menus that should use fetchDataListByMenu (multi-record)
      const multiRecordMenus = [
        "Presentation Details",
        "ATC Code(s)",
        "Product Indication",
        "Pharmaceutical Product",
        "Attachments",
      ];

      async function getSideMenuData(params: {
        regId: any;
        productId: any;
        xevmpdId: any;
        majorVersion:any;
        minorVersion:any;
      }) {
        const result: Record<string, any> = {};

        for (const name of names) {
          const parameters = {
            registrationId: params.regId,
            productId: params.productId,
            menu:name,
            xevmpdId: "",
            majorVersion:params.majorVersion,
            minorVersion : params.minorVersion
          };

          try {
            // For multi-record menus → fetchDataListByMenu
            if (multiRecordMenus.includes(name)) {

              let response; 

              if (name === "Pharmaceutical Product") {
                response = await fetchPharmaceuticalProductData(parameters);
              } else {
                response = await fetchDataListByMenu(parameters);
              }
              const list = response?.data?.fieldDataList || response?.fieldDataList || [];
              result[name] = normalizeMenuListData(list);
            } else {
              // ✅ For single-record menus → fetchSideMenuData
              const { minorVersion, majorVersion, ...filteredParams } = parameters;
              const response = await fetchSideMenuData(filteredParams);
              result[name] = response?.fieldData || {};
            }
          } catch (error) {
            console.error(`❌ Failed to fetch ${name}:`, error);
            // Return consistent structure even on error
            result[name] = multiRecordMenus.includes(name) ? [] : {};
          }
        }

        return result;
      }

      // Fetch all menu data for the selected registration
      const regVersion = regdata?.regVersion || "V0.1";
      const { major, minor } = extractVersion(regVersion);
      const params = {
        regId: regdata?.id,
        productId: regdata?.productId,
        xevmpdId: "",
        majorVersion: major,
        minorVersion:minor

      };

      const data = await getSideMenuData(params);

      // ✅ Just set state (no DB save here)
      setSideMenuData(data);
      setLoading(false);
    };
    const getData = async () => {
      const result = await fetchRelatedProducts(regdata.productId);
      const packages = regdata?.sectionTree?.Packages;
      let RegLinkedPackages = [];
      if (packages?.Packages?.length > 0) {
        RegLinkedPackages = result.data.filter((item: { id: any }) =>
          packages?.Packages?.includes(item.id)
        );
      }
      const filteredRecords = allXevmpdRows.filter(
        (record) =>
          record.registrationId == regdata.id &&
          (record.xevmpdStatus === 0 || record.xevmpdStatus === 2)
      );
      if (filteredRecords.length > 0) {
        const createdPackageIds = new Set<string>();
        let hasRegistrationLevelRecord = false;

        for (const record of filteredRecords) {
          try {
            const parsed = JSON.parse(record.xevmpdData);
            if (parsed?.packLevel === false) {
              hasRegistrationLevelRecord = true;
              break;
            }
            createdPackageIds.add(parsed.PackageData?.id);
          } catch (err) {
            console.warn("⚠️ Failed to parse xevmpdData:", err);
          }
        }
        const selectedregpackids = RegLinkedPackages.map(
          (p: { id: any }) => p.id
        );
        const missingPackages = selectedregpackids.filter(
          (id: string) => !createdPackageIds.has(id)
        );
        const allCreated = selectedregpackids.every((id: any) =>
          createdPackageIds.has(id)
        );
        if (
          (missingPackages.length === 0 && hasRegistrationLevelRecord) ||
          allCreated
        ) {
          setOpenAlert(true);
          setLoading(false);
          return;
        }
      }

      // ✅ No existing record — open XevmpdPackage modal
      setOpenCombined(true);
      setselectedRows(selectedRows);
    };

    // 🟢 Step 5: Run both
    await getData();
    await getmenudata();
  };
  const handleViewClick = React.useCallback((cell: any) => {
    window.open(
      `https://app.${process.env.REACT_APP_STG_DOMAIN}/registrations?modulePath=/registrations/view-registration/${cell.id}`
    );
  }, []);

  const handleBack = () => {
    navigator("/idmp-list", { replace: true });
  };

  const columns = [
    {
      field: "recordID",
      headerName: "Registration ID",
      width: 140,
      // renderCell: (params: any) => <a href="#">{params.row.recordID}</a>,
    },
    { field: "productName", headerName: "Product Name", width: 320 },
    { field: "productType", headerName: "Product Type", width: 220 },
    { field: "procedureType", headerName: "Procedure Type", width: 200 },
    { field: "country", headerName: "Country", width: 220 },
    { field: "region", headerName: "Country Group", width: 290 },
    { field: "regVersion", headerName: "Registration Version", width: 290 },
    // {
    //   field: "actions",
    //   type: "actions",
    //   width: 90,
    //   headerName: "Actions",
    //   getActions: (params: { row: any; }) => [
    //     // <GridActionsCellItem
    //     //   showInMenu
    //     //   label="Edit"
    //     //   icon={<EditIcon />}
    //     //   onClick={handleEditClick}
    //     // />,
    //     //<GridActionsCellItem showInMenu label="View" icon={<RemoveRedEyeIcon />} onClick={() => handleViewClick(params.row)}/>,
    //   ],
    // },
  ];
  useEffect(() => {
    setLoading(true);
    type RegData = {
      sectionTree: {
        Packages: {
          Packages: string[];
        };
      };
      id: number;
      packages?: string[];
    };

    type XevmpdData = {
      xevmpdStatus: number;
      xevmpdData: string;
      registrationId: number;
      packageId: string;
    };

    function filterRegData(regDataList: RegData[], xevmpdList: XevmpdData[]) {
      let filteredRegData = regDataList.filter((reg) =>
        xevmpdList.find(
          (x) =>
            x.registrationId.toString() === reg.id.toString() &&
            (x.xevmpdStatus === 0 || x.xevmpdStatus === 2)
        )
      );
      let removableregrecords = [];
      for (const regrecord of filteredRegData) {
        const hasRegLevelRecord = xevmpdList.some((x) => {
          if (x.registrationId !== regrecord.id) return false;
          if (!(x.xevmpdStatus === 0 || x.xevmpdStatus === 2)) return false;

          try {
            const parsed = JSON.parse(x.xevmpdData);
            return parsed?.packLevel === false;   // <-- if true → remove
          } catch (e) {
            console.warn("Failed to parse xevmpdData for reg:", regrecord.id, e);
            return false;
          }
        });

        if (hasRegLevelRecord) {
          removableregrecords.push(regrecord);
          continue;
        }
         let packages = regrecord?.sectionTree?.Packages?.Packages;

        if (!Array.isArray(packages) || packages.length === 0) {
          removableregrecords.push(regrecord);
          continue;
        }
        
          let allCreated = false;
          xevmpdList.forEach((item) => {
            try {
              const parsed = JSON.parse(item.xevmpdData);
              const packageId = parsed?.PackageData?.id;
              const regid = regrecord.id;
              const xevmpdregid = parsed.Regdata.id;
              if (
                regid == xevmpdregid &&
                (item.xevmpdStatus === 0 || item.xevmpdStatus === 2)
              ) {
              if (Array.isArray(packages) && packages.length > 0 && packageId) {
                packages = packages.filter((item) => item !== packageId);
              } else {
                console.warn(
                  `Skipping package removal for reg ${regid} because packages or packageId is invalid`,
                  { packages, packageId }
                );
              }
            }
              if (packages.length === 0) {
                allCreated = true;
              }
            } catch (e) {
              console.error("Invalid JSON in xevmpdData", e);
            }
          });
        if(allCreated){
          removableregrecords.push(regrecord);
        }
      }
      return removableregrecords;
    }

    const buildIpayloadtemsObject = (response: any[]) => {
      return {
        items: response.map((item) => ({
          regId: item.recordId || item.recordID,
          packageIds:
            item.sectionTree?.Packages?.Packages?.filter(
              (id: string | null) => id !== null
            ) || [],
        })),
      };
    };
    const filterResponseByRegId = (
      response: any[],
      regIdList: { regId: string }[]
    ) => {
      const regIdSet = new Set(regIdList.map(item => item.regId));

      return response.filter(item =>
        regIdSet.has(item.recordId || item.recordID)
      );
    };

    const getRegData = async () => {
      try {
      const regioncodes = await getRegionKMCodes();
      const LocalRegistrationCategoryKMCodes =await LocalRegistrationCategoryCodes();
      //const EEARegionCode = await getRegionKMCodes("EEA");
      const producttypekmcode = await getProductTypeKMCodes();
      const validregstatskmcode = await getRegulatorystatusKMCodes("Valid");
      const approvedregstatskmcode = await getRegulatorystatusKMCodes("Approved");
      const notifiedregstatskmcode = await getRegulatorystatusKMCodes("Notified");
      //const regioncodes = [...EUregioncodes,...EEARegionCode];
      const regstatuscodes = [...validregstatskmcode,...approvedregstatskmcode,...notifiedregstatskmcode];
      const fullRegData = await fetchRegistrationData(1, 999999,regioncodes,producttypekmcode,regstatuscodes,LocalRegistrationCategoryKMCodes);
      const sourceRegistrations = fullRegData.data ?? [];
      setAllRegistrations(sourceRegistrations);
      const registrations = excludeNonEuCentralisedRegistrations(sourceRegistrations);
      const payload = buildIpayloadtemsObject(registrations);
      console.log(payload);
      const response = await fetcheligibleregistrations(
       payload
      );
      const elegibleregrecords = response.results;
      setEleigibleRegRecords(elegibleregrecords);
      const finalregdata = filterResponseByRegId(registrations,elegibleregrecords);
      //setallXevmpdRows(xevmpddata);

      // const removregrecords = filterRegData(fullRegData.data, xevmpddata);
      // const childIds = new Set(removregrecords.map((item: any) => item.id));
      // const filteredRows = fullRegData.data.filter(
      //   (item: any) => !childIds.has(item.id)
      // );

      // const filteredTotal = filteredRows.length;

      // const start = (RegpaginationModel.page - 1) * RegpaginationModel.pageSize;
      // const end = start + RegpaginationModel.pageSize;

      // const paginatedRows = filteredRows.slice(start, end);

      setGridrows(finalregdata);
      } finally {
        setLoading(false);
      }
    };

    getRegData();
  }, []);

  return (
    <>
      <div className="module-page">
        <Box className="wizard-page">
          <Grid container>
            <Grid item md={12}>
              <Typography className="heading-typography" gutterBottom>
                Add xEVMPD
              </Typography>
            </Grid>
          </Grid>
          <Grid container>
            <Grid item md={12}>
              <div className="form-group">
                <label className="form-label">
                  Select a Registration{" "}
                  <span aria-hidden="true" className="asterisk">
                    *
                  </span>
                </label>
              </div>
            </Grid>
          </Grid>
          <Box
            className="stepper-container"
            display={"flex"}
            flexDirection={"column"}
          >
            <div className="row">
              <div className="col-12">
                <DataGridPremium
                  rows={Gridrows}
                  columns={columns}
                  rowSelectionModel={rowSelectionModel}
                  onRowSelectionModelChange={(newSelection) => {
                    const singleSelection = newSelection.slice(-1);
                    setRowSelectionModel(singleSelection);
                    newSelection.length > 0?setInitiateButtonValidation(false):setInitiateButtonValidation(true);
                  }}
                  className="react-table table_size-has--row2"
                  slots={{
                    toolbar: GridToolbar,
                    noRowsOverlay: NoRecordsFound,
                    noResultsOverlay: NoRecordsFound,
                  }}
                  checkboxSelection
                  disableMultipleRowSelection
                  slotProps={{
                    baseCheckbox: {
                      icon: <RadioButtonUncheckedIcon />,
                      checkedIcon: <RadioButtonCheckedIcon />,
                      // optional: remove ripple effect
                      disableRipple: true,
                      sx: {
                        display: "flex",
                        alignItems: "center",
                        gap: "10px",
                        position: "relative",
                      },
                    },
                    toolbar: {
                      showQuickFilter: true,
                      filterModel: true,
                      csvOptions: {
                        fileName: "xEVMPD_Records",
                      },
                      excelOptions: {
                        fileName: "xEVMPD_Records",
                      },
                    },
                  }}
                  initialState={{
                    pinnedColumns: { right: ["actions"] },
                    pagination: { paginationModel: { pageSize: 50 } },
                  }}
                  pagination
                  localeText={localeText}
                  // pageSizeOptions={[
                  //   50,
                  //   100,
                  //   200,
                  //   500,
                  //   RegpaginationTotalRecord,
                  // ]}
                   pageSizeOptions={[
                    50,
                    100,
                    200,
                    500
                  ]}
                />
              </div>
            </div>
            <Box
              sx={{
                marginTop: 4,
                display: "flex",
                flexDirection: "row",
                justifyContent: "flex-end",
              }}
            >
              <Button variant="text" onClick={handleBack} sx={{ mr: 1 }}>
                Cancel
              </Button>
              <Button variant="contained" onClick={handleNext} disabled = {initiateButtonValidation}>
                Initiate xEVMPD
              </Button>
            </Box>
          </Box>
        </Box>
      </div>
      <XevmpdPackage
        open={openCombined}
        onClose={() => setOpenCombined(false)}
        regdata={selectedRows}
        sideMenuData={sideMenuData}
        eleigibleRegrecords = {eleigibleRegRecords}
        registrations={allRegistrations}
        eeaSiblings={eeaSiblings}
      />
      <Dialog open={Boolean(createError)} onClose={() => setCreateError("")}>
        <DialogTitle>Cannot create xEVMPD</DialogTitle>
        <DialogContent>
          <DialogContentText>{createError}</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button variant="contained" onClick={() => setCreateError("")}>
            Close
          </Button>
        </DialogActions>
      </Dialog>

      {/* Snackbar for warning */}
      <Snackbar
        open={showWarning}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        sx={{
          top: 80, // distance from top like a toast
        }}
        onClose={() => setShowWarning(false)}
        autoHideDuration={3000}
      >
        <Alert
          severity="error"
          icon={false}
          sx={{
            backgroundColor: "#FDEAEA", // light red-pink
            color: "#B71C1C", // dark error text
            border: "1px solid #F5C6CB", // subtle border
            borderRadius: "0px",
            width: "100%",
            maxWidth: "600px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontWeight: 500,
            boxShadow: "none", // remove shadow
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <Box
              component="span"
              sx={{
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
                backgroundColor: "#B71C1C",
                color: "white",
                borderRadius: "50%",
                width: 20,
                height: 20,
                fontSize: 12,
                fontWeight: "bold",
                mr: 1,
              }}
            >
              !
            </Box>
            <Typography variant="body2" sx={{ fontWeight: 500 }}>
              Please select a Registration
            </Typography>
          </Box>
        </Alert>
      </Snackbar>
      <Loading open={loading} />
      {/* <Dialog
      open={openAlert}
      onClose={() => setOpenAlert(false)}
      aria-labelledby="xevmpd-alert-title"
      aria-describedby="xevmpd-alert-description"
      slotProps={{
        backdrop: {
          sx: {
            backgroundColor: 'rgba(15, 15, 15, 0.4) !important',
          },
        },
      }}
      PaperProps={{
        elevation: 8,
        sx: {
          borderRadius: 0,
          minWidth: 400,
        },
      }}
    >
      <DialogTitle id="xevmpd-alert-title">xEVMPD</DialogTitle>
      <DialogContent>
        <DialogContentText id="xevmpd-alert-description">
          xEVMPD record(s) already exist for the selected registration.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => setOpenAlert(false)} autoFocus>
          OK
        </Button>
      </DialogActions>
    </Dialog> */}
      <Dialog
        open={openAlert}
        onClose={() => setOpenAlert(false)}
        aria-labelledby="xevmpd-alert-title"
        aria-describedby="xevmpd-alert-description"
        slotProps={{
          backdrop: {
            sx: {
              backgroundColor: "rgba(15, 15, 15, 0.4) !important",
            },
          },
        }}
        PaperProps={{
          elevation: 8,
          sx: {
            borderRadius: 0,
            minWidth: 400,
          },
        }}
      >
        {/* Title with Close Button */}
        <DialogTitle
          id="xevmpd-alert-title"
          sx={{ fontWeight: "bold", pr: 5, fontSize: 16 }}
        >
          xEVMPD already exists
          <IconButton
            aria-label="close"
            onClick={() => setOpenAlert(false)}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        {/* Warning Icon & Message */}
        <DialogContent sx={{ textAlign: "center" }}>
          <Box
            component="img"
            src={AlertIcon}
            alt="Warning"
            sx={{ marginTop: 5 }} // Set the size of the image
            // sx={{ width: 250, height: 120, marginBottom: 5 }} // Set the size of the image
            data-testid="alert-icon"
          />
          <Typography variant="body1" sx={{ fontSize: "24px", marginTop: 5 }}>
            xEVMPD record(s) already exist for the selected registration.
          </Typography>
        </DialogContent>

        {/* OK Button */}
        <DialogActions sx={{ p: 2 }}>
          <Button
            onClick={() => setOpenAlert(false)}
            variant="contained"
            sx={{
              backgroundColor: "#1976d2",
              "&:hover": { backgroundColor: "#1565c0" },
              px: 3,
            }}
          >
            OK
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default IdmpAdd;
